import axios from "axios";
import Axios from "./Axios";

 const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "https://shopmytool.in";

//  const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://192.168.0.165:8000'

 

// -------------------- HELPER FUNCTIONS --------------------
const getRequest = async (url, params = {}) => {
  try {
    const response = await Axios.get(url, { params });
    return response.data;
  } catch (error) {
    console.error(`GET ${url} failed:`, error?.message || error);
    throw error;
  }
};

const postRequest = async (url, body = {}) => {
  try {
    const response = await Axios.post(url, body);
    return response.data;
  } catch (error) {
    console.error(`POST ${url} failed:`, error?.message || error);
    throw error;
  }
};
export const deleteRequest = async (url) => {
  try {
    const response = await Axios.delete(url);
    return response.data;
  } catch (error) {
    console.error(
      `DELETE ${url} failed:`,
      error?.response?.data || error?.message || error,
    );
    throw error;
  }
};

export const putRequest = async (url, payload = {}) => {
  try {
    const response = await Axios.put(url, payload);
    return response.data;
  } catch (error) {
    console.error(`PUT ${url} failed:`, error?.message || error);
    throw error;
  }
};

export const patchRequest = (url, data) => Axios.patch(url, data);
// -------------------- API METHODS --------------------

// Menu (Categories & Subcategories)
export const getMenu = () => getRequest("/menu/");
// apiService.js
export const getMenu1 = async () => {
  const res = await getRequest("/menu/");
  return Array.isArray(res?.Data) ? res.Data : [];
};


// Banners
export const getBanners = () => getRequest("/banner/");

// Brands
export const getBrands = () => getRequest("/brand/");

// Brand page products
export const getBrandPage = (brand) =>
  getRequest("Brandcatagorylist/?brand", { brand });

// Brand product list by type & subcategory
export const getBrandProductList = ({ type, subcategory }) =>
  getRequest("lodingpageproductlist/?", { type, subcategory });
export const getProductsByCategory = (category) =>
  getRequest("/lodingpageproductlist/", {
    type: "category",
    category: category,
  });

// Subcategory details
export const getSubcategoryDetails = (subcategory) =>
  getRequest("lodingpageproductlist/", { type: "subcategory", subcategory });
export const getProductById = (productid) =>
  getRequest("lodingpageproductlist/", {
    type: "modelno",
    productid,
  });

// Shop by Spares
export const shopBySpares = () => getRequest("/Shopbyspares/");

// Shop by Brand
export const shopByBrand = () => getRequest("/brand/");
//get blogs
export const getBlogs = () => getRequest("/blogs/");
export const createBlog = (data) => postRequest("/blogs/", data);
export const updateBlog = async (id, data) => {
  try {
    const response = await patchRequest(`/blogs/${id}/`, data);
    return response;
  } catch (error) {
    console.error(
      `PATCH /blogs/${id}/ failed:`,
      error?.response?.data || error?.message || error,
    );
    throw error;
  }
};
export const deleteBlog = (id) => deleteRequest(`/blogs/${id}/`);

// Essential spares
export const getEssentialSpares = () => getRequest("/Essentialspares/");

// Product details
export const getProductDetails = (productid) =>
  getRequest("/lodingpageproductlist/?type=modelno&productid", { productid });
export const getCategoryProductList = (category) =>
  getRequest("/categoryproductlist/", { category });

// Add to Recently Viewed
export const addToRecent = ({ customerid, productid }) =>
  postRequest("/Recentlyviewedlist/", { customerid, productid });

// Similar products
export const getSimilarProducts = (productid) =>
  getRequest("/similarproducts/", { productid });

// Product spares
export const getProductSpares = (productid) =>
  getRequest("/produsapreparts/", { productid });

// Product ratings
export const getRatings = (productid) =>
  getRequest("/productrating/", { productid });

// New arrivals
export const newArrivals = () => getRequest("/Newarrivals/");
export const Recommended1 = () => getRequest("/Recomendedproducts/");

// Recently viewed products (using localStorage for userId)
export const getRecentlyViewed = () => {
  const userId = localStorage.getItem("userid");
  if (!userId) return [];
  return getRequest(
    `/Recentlyviewedlist/?customerid=${encodeURIComponent(userId)}`,
  );
};

// Order invoice
export const orderInvoice = (orderid) =>
  postRequest("/Purchaseordergetdtl/", [{ orderid }]);

// Wallet
export const getWallet = () => getRequest("/wallet_get/");

// Dashboard cards
export const getDashboardCards = () => getRequest("/dashboardcards/");

// Most viewed products
export const getMostViewed = () => getRequest("/most_viewed_list/");

// Professions
export const getProfessions = () => getRequest("/ShopProfessionList/");

// Products by profession
export const getShopProfession = (profession) =>
  getRequest(`/ShopProfession/?profession=${profession}`);

// Special discount products
export const getSpecialProducts = () => getRequest("/SpecialDiscountList/");

// -------------------- EXPORT AXIOS --------------------

// Admin panel
// -------------------- DASHBOARD APIs --------------------

// PO Orders – Pending packing
export const getPOOrders = () => getRequest("/Purchaseorderget/");

// Pending shipment creation
export const getPendingShipmentCreation = () =>
  getRequest("/pendingshipmentcreation/");

// Packing list / Pickup request
export const getPackingList = () => getRequest("/packinglist/");
export const getOtherTransport = () => getRequest("/other_transport/");
export const getPackingListOrderid = (orderid) =>
  getRequest(`/Packing/?orderid=${orderid}`);
export const getProductList = (modelno) =>
  getRequest(`/productlist/?modelno=${modelno}`);
export const getOrderidBarcode = (barcode) =>
  getRequest(`/getproductid/?barcode=${barcode}`);
export const updatePackingListOrderid = (orderid, payload) =>
  postRequest(`/Packing/?orderid=${orderid}`, payload);
export const updatePackingListproductid = (payload) =>
  postRequest(`/getproductid/?`, payload);
export const getServiceenquiries = (x, y) =>
  getRequest(`/Processedqyrieys/?xdate=${x}&ydate=${y}`);
export const getUserServiceenquiries = (id, x, y) =>
  getRequest(`/Processedqyrieys/?userid=${id}&xdate=${x}&ydate=${y}`);
export const SetEnquiry = (payload) => postRequest(`/Enquirys/?`, payload);
export const getTicketEnquiry = (payload) =>
  getRequest(`/Enquirysdtl/?`, payload);
export const EditTicketEnquiry = (payload) =>
  postRequest(`/Enquirysdtl/?`, payload);
export const EditEnquiry = (payload) => postRequest(`/Enquirysdtl/?`, payload);
export const UserEnquiries = (payload) =>
  getRequest(`/Enquirysuser/?`, payload);
export const ClosedEnquiries = (x, y) =>
  getRequest(`/Closedenqyrieys/?xdate=${x}&ydate=${y}`);
export const ClosedUserEnquiries = (id, x, y) =>
  getRequest(`/Closedenqyrieys/?userid=${id}&xdate=${x}&ydate=${y}`);

export const getServiceCentersList = () => getRequest("/get_servicecentes/");
export const getBarcodeList = (payload) =>
  getRequest(`getbarcodelist/?productid=${payload}`);

// Create product (uses Axios instance with token)
export const createProduct = (payload) => Axios.post("/productlist1/", payload);
// Fetch products for admin
// apiService.js
export const getProductlist = async (usertype) => {
  const response = await Axios.get("/productlist1/", {
    params: { usertype },
  });
  return response.data; // return full response, not just Data
};
export const getProductSpecifications = async () => {
  const response = await Axios.get("/ProductSpecifications/");
  return response.data;
};
// ✅ Update Product Specification (PATCH)
export const updateProductSpecification = async (id, payload) => {
  return await patchRequest(`/ProductSpecifications/${id}`, payload);
};
export const addProductSpecification = async (payload) => {
  return await postRequest(`/ProductSpecifications/`, payload);
};
export const createshipment = async (payload) => {
  return await postRequest(`/createshipment/`, payload);
};
// Delete specification by ID
export const deleteProductSpecification = async (id) => {
  return await deleteRequest(`${API_BASE_URL}/ProductSpecifications/${id}`);
};
export const refreshData = async () => {
  try {
    const response = await getRequest("/refresh/");
    return response.data; // return only the data
  } catch (error) {
    console.error("Refresh API error:", error);
    throw error; // rethrow to handle in component
  }
};

export const uploadProductSpecsCSV = (formData) =>
  Axios.post("/ProuctExcelUploadAPIView/", formData);
// Get banners by type (Banner, Brand, Category, etc.)
export const uploadBannerImage = (formData, type) => {
  return getRequest(`/ImagesView/?type=${type}`, formData);
};
export const getBannerImages = (type) => {
  return getRequest(`/ImagesView/?type=${type}`);
};

// Upload image from modal
export const uploadModalImageService = (formData) =>
  postRequest("/fileuploadview/", formData);
export const getCouponsService = () => {
  return getRequest("/Coupons/");
};
export const createCouponService = async (payload) => {
  return await postRequest("/Coupons/", payload);
};

export const getClientListService = () => {
  return getRequest("/Clientlist1/");
};

export const updateBannerImageService = (id, payload) => {
  return patchRequest(`/ImagesView/${id}`, payload);
};
export const getAllInternalUsers = () => {
  return getRequest("/Internaluser1/");
};
export const getPendingDealerList = () => {
  return getRequest("/pendingdealerlist/");
};

// export const getBanners= () => {
//   return getRequest("/pendingdealerlist/");
// };

// apiService.js
export const toggleDealerStatus = (id, payload = {}) => {
  // if payload is not passed, default to sending { id }
  const data = Object.keys(payload).length ? payload : { id };

  return patchRequest(`pendingdealerlist/${id}`, data);
};

export const createClientService = (payload) =>
  postRequest("/Clientlist1/", payload, {
    headers: { "Content-Type": "application/json" },
  });
// services/apiService.js

export const createInternalUserService = (payload) =>
  postRequest("/api/register/", payload, {
    headers: { "Content-Type": "application/json" },
  });
export const getCartCount = (userId) => {
  return getRequest(`/getcartcount/?userid=${userId}`);
};
export const getCustomerWarrantyList = () => {
  return getRequest(`/warranty/`);
};
export const getDealerStates = () => {
  return postRequest(
    "/GetDealersStates/",
    {},
    {
      headers: { "Content-Type": "application/json" },
    },
  );
};

// 2️⃣ Assign dealer (POST method, payload as you described)
export const assignDealer = (payload) => {
  return postRequest("/Dealerassain/", payload, {
    headers: { "Content-Type": "application/json" },
  });
};
// 2️⃣ Get Cities by State
export const getDealerCities = (state) => {
  return postRequest(
    "/GetDealersCities/",
    { state },
    {
      headers: { "Content-Type": "application/json" },
    },
  );
};

// 3️⃣ Get Dealers by City
export const getDealersList = (city) => {
  return postRequest(
    "/GetDealersList/",
    { city },
    {
      headers: { "Content-Type": "application/json" },
    },
  );
};
export const getPowertoolsList = () => {
  return getRequest(`get_powertools_list/`);
};
export const addRack = (productid, rack) => {
  return getRequest(
    `/addrack/?productid=${productid}&rack=${encodeURIComponent(rack)}`,
  );
};
export const removeRack = (productid, rack) => {
  return getRequest(
    `/removerack/?productid=${productid}&rack=${encodeURIComponent(rack)}`,
  );
};
export const updateStock = (productid, rack, qty) => {
  const payload = {
    rack: rack,
    qty: qty,
  };

  return patchRequest(`/StockView/${productid}`, payload);
};
export const getSparesstocklist = () => {
  return getRequest(`/get_spares_list/`);
};
export const getNotifiedList = async () => {
  return await getRequest("/Notifiedme1/");
};
export const updateProductlist = async (productid, payload) => {
  return await patchRequest(`/productlist1/${productid}`, payload);
};
export const getProductEditDetails = async (productid) => {
  return await getRequest("/ProductEdit/", { productid });
};

export const getCartReportService = async () => {
  return await getRequest("/cartreport/");
};

export const getWishlistRecordsService = async () => {
  return await getRequest("/wishlistrecords/");
};
export const getOrdersRegisterReport = (fromdate, todate) => {
  return postRequest(
    "/ordersregister/",
    { fromdate, todate },
    {
      headers: { "Content-Type": "application/json" },
    },
  );
};
export const getDiscountListService = async () => {
  try {
    const response = await getRequest("/Discountlist/");
    return response.data || [];
  } catch (error) {
    console.error("Error fetching discount list:", error);
    return [];
  }
};

export const getWarrentyClimeList = async () => {
  try {
    const response = await getRequest("/warranty_claim/");
    return response.data || [];
  } catch (error) {
    console.error("Error fetching warranty claim list:", error);
    return [];
  }
};
export const toggleDiscountActiveService = async (discountid, active) => {
  const payload = { discountid, active };
  return await putRequest("/insdiscounts/", payload);
};

export const getProductListByModel = async (modelno) => {
  try {
    const data = await getRequest(`${API_BASE_URL}/productlist/`, { modelno });
    return data; // assuming API returns array of products
  } catch (error) {
    console.error("Error fetching product list:", error);
    return [];
  }
};
export const toggleProductStatus = async (id, isActive) => {
  try {
    const response = await axios.patch(`${API_BASE_URL}/productlist/${id}/`, {
      is_active: isActive,
    });
    return response.data;
  } catch (error) {
    console.error("Error toggling status:", error);
    throw error;
  }
};

// Create spare discount
export const createSpareDiscount = async (payload) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/sparediscount/`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error creating spare discount:", error);
    throw error;
  }
};

// freeitems
export const getStockModelsService = async () => {
  return await getRequest("/StockView/?type=power%20tools");
};

/* 🔹 Create free product */
export const createFreeProductService = async (payload) => {
  return await postRequest("/freeitems/", payload);
};
export const postHologramIssue = async (payload) => {
  return await postRequest("/HologramIssue/", payload);
};

export const getFreeItemsService = () => {
  return getRequest("/getfreeitems/");
};
export const updateFreeItemStatus = async (id, status) => {
  const payload = { id, status };
  return await patchRequest(`/freeitems/`, payload);
};
export const getOrderTrackingById = async (orderId) => {
  return await getRequest(`/ordertracking/?id=${orderId}`);
};
export const getRazorPayOrders = async (from, to) => {
  const res = await getRequest(
    `/getorderdetails/?fromdate=${from}&todate=${to}`,
  );
  return res; // already contains array
};
// export const getProductComments  = async () => {
//   return await getRequest(`/ProductComments/`);
// };
// adminorderslist

export const getProductComments = async () => {
  const token = localStorage.getItem("token"); // or sessionStorage

  return await axios.get(`${API_BASE_URL}/ProductComments/`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const getOrdersList = async () => {
  const token = localStorage.getItem("token"); // or sessionStorage

  return await axios.get(`${API_BASE_URL}/Purchaseorderget/`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const toggleCommentStatus = async (cid, active) => {
  const token = localStorage.getItem("token");

  return await axios.patch(
    `${API_BASE_URL}/ProductComments/`,
    { cid, active },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
};
export const cancelOrder = async (payload) => {
  return await postRequest("/cancelorder/", payload);
};
// export const cancelOrder = (orderid, desc) => {
//   return axios.post("/cancelorder/", {
//     orderid,
//     desc,
//   });
// };

// export const cancelOrder = async (orderid, desc) => {
//   const token = localStorage.getItem("token");
//   return await axios.post(
//     `${API_BASE_URL}/cancelorder/`,
//     { orderid, desc },
//     {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "application/json",
//       },
//     }
//   );
// };

export const getVisitorsList = () => {
  return getRequest("expo_visitors_list/");
};

export const getCancelledOrdersService = () => {
  return getRequest("/cancel_order_list/");
};
export const getDispatchListService = () => {
  return getRequest("/Dispatchlist/");
};
export const returnOrderService = async (payload) => {
  return await postRequest("/returnorder/", payload);
};
// export const getFailureInvoiceList = async () => {
//   return await getRequest("/focusinvfailurelist/");
// };
export const getFailureInvoiceList = async () => {
  const token = localStorage.getItem("token"); // or sessionStorage

  return await axios.get(`${API_BASE_URL}/focusinvfailurelist/`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const changePasswordService = async (payload) => {
  return await postRequest("/Changepassword/", payload);
};

export const insertProductDiscounts = async (payload) => {
  return await postRequest("/insdiscounts/", payload);
};
export const updateProductDiscounts = async (payload) => {
  return await patchRequest("/insdiscounts/", payload);
};
// apiService.js

export const createDealerDiscount = (payload) =>
  postRequest("/productsmrpdealerdiscounts/", {
    category: payload.category,
    subcategory: payload.subcategory,
    type: payload.type, // "delardiscount"
    value: payload.value, // "10"
  });
export const updateClientService = async (clientId, payload) => {
  try {
    const response = await patchRequest(`/Clientlist1/${clientId}`, payload);
    return response.data;
  } catch (error) {
    console.error("Failed to update client:", error);
    throw error; // rethrow to handle in component
  }
};
export const updateInternalUser = (userId, payload) => {
  return patchRequest(`/Internaluser1/${userId}`, payload);
};

export const createFaqService = async (payload) => {
  return await postRequest("/faqs/", payload);
};
export const getFaqService = () => {
  return getRequest("/faqs/");
};
export const updateFaqService = (sno, payload) => {
  return patchRequest(`/faqs/${sno}/`, payload);
};
export const deleteFaqService = (id) => {
  return deleteRequest(`/faqs/${id}/`);
};
export const getTestimonialsService = () => {
  return getRequest("/customer-testimonials/");
};

export const getDealerWarrantyList = () => {
  return getRequest(`/warrentylist/`);
};
export const getDealerCustomerList = (id) => {
  return getRequest(`/markeing_customerlist/?userid=${id}`);
};
export const updateDealerWarranty = (payload) => {
  return putRequest("/warrentylist/", payload);
};
export const getSettings = () => {
  return getRequest("/SettingsAPIView/");
};
export const updateSettings = (payload) => {
  return putRequest("/SettingsAPIView/", payload);
};
export const getLuckyDrawUsers = () => {
  const today = new Date().toISOString().split("T")[0];

  return getRequest(
    `/LuckyDrawUsersAPIView/?from_date=${today}&to_date=${today}`
  );
};
export const postLuckyDrawUser = (payload) => {
  return postRequest(`/LuckyDrawUsersAPIView/`, payload);
};
export const getLuckyDrawWinnerList = () => {
  return getRequest(`/lucky_draw_winner_list/`);
};
export const claimLuckyDrawWinner = (payload) => {
  return postRequest(`/lucky_draw_winner_list/`, payload);
};
export const getPincodeService = (pincode) => {
  return getRequest(
    `/getpincodeservice/?filter_codes=${encodeURIComponent(pincode)}`
  );
};
export const getBankTnx = () => getRequest("/get_bank_tnx/");
export const updateBankTnx = (payload) =>
  patchRequest("/get_bank_tnx/", payload);
export const submitContactUs = (payload) => {
  return postRequest(`/contact_us/`, payload);
};
// -------------------- CREATE PRODUCT DISCOUNT --------------------

export default Axios;
